<div class="lvi-content">
    <div class="avatar">
        <span>{{ data.reference | slice: 0:3 }}</span>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onSelect()">{{ data.reference }} - {{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.code1">
                <strong [translate]="'admin.entreprise.analytique.axe6.code1'"></strong>
                <span>{{ data.code1 }}</span>
            </li>
            <li *ngIf="data.code2">
                <strong [translate]="'admin.entreprise.analytique.axe6.code2'"></strong>
                <span>{{ data.code2 }}</span>
            </li>
            <li *ngIf="data.dateDebut">
                <strong [translate]="'admin.entreprise.analytique.axe6.dateOuverture'"></strong>
                <span>{{ data.dateDebut | date: 'shortDate' }}</span>
            </li>
            <li *ngIf="data.dateFin">
                <strong [translate]="'admin.entreprise.analytique.axe6.dateFermeture'"></strong>
                <span>{{ data.dateFin | date: 'shortDate' }}</span>
            </li>
            <li *ngIf="data.actif !== null">
                <strong [translate]="'admin.entreprise.analytique.axe6.infos.actif'"></strong>
                <span>{{ (data.actif ? 'global.oui' : 'global.non' ) | translate }}</span>
            </li>
            <li *ngIf="!!filtres">
                <strong [translate]="'admin.entreprise.analytique.axe6.infos.filtres'"></strong>
                <span>{{ filtres }}</span>
            </li>
        </ul>
    </div>
</div>
